import { actions as collection } from '@/plugins/Collection'

export default collection.toOptions({
  under5K: 'Under £5,000',
  between5kAnd10k: '£5,000 to £10,000',
  between10kAnd20k: '£10,001 to £20,000',
  between20kAnd30k: '£20,001 to £30,000',
  between30kAnd40k: '£30,001 to £40,000',
  over40k: 'Over £40,000'
})
